module.exports = __webpack_public_path__ + "5b5ab759cfe2daf278f94a6f4bd4faf0.jpg";